<script setup lang="ts">
import { onMounted, ref } from 'vue';
import i18n from '@/localization/i18n';
import CustomInput from '@/views/components/CustomInput.vue';
import { storeToRefs } from 'pinia';
import { useBusinessRequestFormStore } from '@/pages/index/stores/business-request-form-store';
import { logNewEvent } from '@/services/modules/firebase';

const businessRequestFormStore = useBusinessRequestFormStore()
const {titleFormData, titleFormErrors} = storeToRefs(businessRequestFormStore)


import BusinessRequestProgressBar from "./BusinessRequestProgressBar.vue";

const t = i18n.global.t

onMounted(() => {})

const validateForm = () =>{
    titleFormErrors.value.title = !titleFormData.value.title ? t("w_msg_frmVal_required") : ""
    if(titleFormErrors.value.title === ''){
        logNewEvent("presta_request_submit_title")
        businessRequestFormStore.next_step('urgency')
    }
}
</script>

<template>
    <div class="rounded main fullHeight" style="height: 550px">
        <BusinessRequestProgressBar />
        <div class="fullRemainingHeight">
            <div class="expanded" style="justify-content: space-between;">
                <div class="h-style h3-style use-poppins text-center mt-4">
                    {{ t("w_txt_business_request_confirm_title") }}
                </div>
                <div class="mt-4 mx-md-5">
                    <p class="">
                        {{ t("w_txt_business_request_title_instruction") }}
                    </p>
                </div>
                <div class="validate-form px-2 mx-md-2 mt-5">
                    <form @submit.prevent class="col-12 col-sm-12 mb-2 border-end-light">
                        <div class="row">
                            <div class="col-12 mb-2 mt-1">
                                <CustomInput
                                    type="text"
                                    maxlength="64"
                                    id="new_email"
                                    v-model:value="titleFormData.title"
                                    :placeholder="t('w_txt_business_request_title_placeholder')"
                                    :errors="titleFormData.title.length == 0 ? titleFormErrors.title : ''"
                                        />
                                    <!-- :placeholder="t('w_txt_csBusinessRequestTitlePlaceholder')" -->
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div style="margin-top: auto; margin-bottom:15px ">
                <button
                    @click="validateForm"
                    type="button"
                    class="btn btn-primary mt-2 mb-2 on-action-btn custom-btn-width"
                    :disabled="titleFormData.title.length == 0"
                    :class="{ 'invalid-btn-style': titleFormData.title.length == 0}"
                    >
                    {{ t("w_act_business_request_next") }}
                </button>
            </div>
        </div>

    </div>
</template>

<style scoped>
.btn-primary:focus{
    background-color: #FEB23C !important;
}

.main {
    padding-top: 15px;
    position: relative;
}

.bg {
    background-color: #FEB23C !important;
}

.fullHeight {
    min-height: 100%;
    z-index: 1px;
    border: none !important;
    display: flex;                  
    flex-direction: column;
}

.fullRemainingHeight {
    display: flex;                  
    flex-direction: column; 
    height: 100%;  
}

.expanded{
    flex-grow: 1;
    margin-left: 10px;
    margin-right: 10px;
}

.invalid {
    background-color: #efefef !important;
    border-color: #82868b !important;
    color: #82868b !important;
}

.custom-btn-width {
    min-width: 130px;
}

/* Medium devices (md) - 768px and up */
@media (min-width: 768px) {
    /* Styles for medium screens */
    .expanded{
        margin-left: 50px !important;
        margin-right: 50px !important;
    }

    .custom-btn-width {
        min-width: 150px !important;
    }
}

</style>